import {gsap} from "gsap";
import {DrawSVGPlugin} from "gsap/DrawSVGPlugin";
import {MorphSVGPlugin} from "gsap/MorphSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin, MorphSVGPlugin);

jQuery(document).ready(function () {
  let cards = jQuery('.component_card_elu');

  cards.each(function () {
    let card = jQuery(this);
    let card_width = jQuery(document).width();
    let card_hover = card.find('.card-hover');

    const tl_1 = gsap.timeline({repeat: 0, repeatDelay: 1});
    if (card_width >= 1024) {
      tl_1.fromTo(card_hover, {
          yPercent: 100,
          duration: 1,
        },
        {
          yPercent: 0,
          duration: 1,
        }
      );
      tl_1.reverse();

      card.on('mouseenter', () => {
        tl_1.play();
      });
      card.on('mouseleave', () => {
        tl_1.reverse();
      });
      card.on('focusin', () => {
        tl_1.play();
      });
      card.on('focusout', () => {
        tl_1.reverse();
      });
    }
  });
});
